<template>
  <el-main class="iDalgo-Template-Edit">
    <!-- Breadcrumb __ First row -->
    <el-row type="flex" class="card align-center">
      <el-col :span="18">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'templates' }">{{ $t('iDalgoListEdit.templates') | capitalize }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ template.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="6" class="flex-end">
        <button @click="handleSave" class="button-icon">
          <svgicon name="save"></svgicon>
          <span>{{ $t('actions.save') }}</span>
        </button>
        <button @click="showIntegrationLink" class="button-icon">
          <svgicon name="link"></svgicon>
          <span>{{ $t('actions.share') }}</span>
        </button>
        <button @click="handleDelete" class="button-icon">
          <svgicon name="bin"></svgicon>
          <span>{{ $t('actions.delete') }}</span>
        </button>
      </el-col>
    </el-row>

    <!-- Save status __ Second row -->
    <el-row>
      <span v-if="template.createdAt" class="template-time">{{ $t('iDalgoListEdit.saveStatus.createdAt') }} :<b>{{ template.createdAt | moment('DD/MM/Y à HH:mm') }}</b></span>
      <span v-if="template.updatedAt" class="template-time">{{ $t('iDalgoListEdit.saveStatus.updatedAt') }} :<b>{{ template.updatedAt | moment('DD/MM/Y à HH:mm') }}</b></span>
    </el-row>

    <!-- Sections ___ Third row left section -->
    <el-row class="flex-start" :gutter="20" type="flex">
      <el-col :span="17" id="relative-element" class="mainContent">
        <el-row>
          <i-dalgo-list-title />
        </el-row>
        <i-dalgo-sections />
      </el-col>

      <!-- Players ___ Third row right section -->
      <el-col :offset="1" :span="6">
        <i-dalgo-player-search />
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('iDalgoDialogs.integrationLink.title')"
      :visible.sync="integrationLinkDialogVisible"
      width="50%"
      center>
      <div class="mrg-20"></div>
      <pre>{{ integrationLink }}</pre>
      <span slot="footer" class="dialog-footer integrationLink-footer">
        <el-button
          type="primary"
          @click="copyToClipboardHandler"
          :border="false">{{ $t('actions.copy') }}</el-button>
        <el-button @click="integrationLinkDialogVisible = false">{{ $t('actions.cancelButton') }}</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import iDalgoPlayerSearch from '@/components/iDalgo-Player-Search'
import iDalgoSections from '@/components/iDalgo-Sections'
import iDalgoButton from '@/components/iDalgo-Button'
import iDalgoListTitle from '@/components/iDalgo-List-Title'
import { iframeBundle } from '@/services/generators'
import { mapGetters } from 'vuex'

export default {
  name: 'iDalgo-Template-Edit',
  components: {
    iDalgoPlayerSearch,
    iDalgoSections,
    iDalgoButton,
    iDalgoListTitle
  },
  computed: {
    ...mapGetters({
      template: 'templates/template',
      size: 'templates/size',
      sections: 'templates/sections',
      listPlayers: 'templates/listPlayers',
      allPlayers: 'players/players'
    })
  },
  data () {
    return {
      integrationLink: '',
      integrationLinkDialogVisible: false
    }
  },
  methods: {
    async handleSave (notify = true) {
      // Notifications
      if (notify) {
        // Check if enough players in sections to be playable -- Non blocking
        const hasEnoughPlayersSelected = this.size - this.sections.map(section => section.size).reduce((a, b) => a + b)
        if (hasEnoughPlayersSelected) {
          this.$notify({
            type: 'warning',
            title: this.$t('notifications.warningTitle'),
            message: this.$t('iDalgoListEdit.notifications.hasNotEnoughPlayersSelected')
          })
        }
        const hasEnoughPlayersInSections = this.sections.map(section => {
          if (section.size < section._players.length) {
            return true
          }
          return false
        }).includes(false)
        if (hasEnoughPlayersInSections) {
          setTimeout(() => {
            this.$notify({
              type: 'warning',
              title: this.$t('notifications.warningTitle'),
              message: this.$t('iDalgoListEdit.notifications.hasNotEnoughPlayersInSections')
            })
          }, 10)
        }
      }

      try {
        // Securise data -- Remove getter & setter
        const data = JSON.parse(JSON.stringify(this.sections))
        await this.$store.dispatch('templates/updateSections', { templateId: this.$route.params.id, sections: data })
        setTimeout(() => {
          this.$notify.success({
            title: this.$t('iDalgoListEdit.notifications.saveSuccess.title'),
            message: this.$t('iDalgoListEdit.notifications.saveSuccess.message')
          })
        }, 20)
      } catch (e) {}
    },
    cancelEdit () {
      this.$store.commit('templates/SECTION_UPDATED', '')
      this.$store.commit('players/SEARCH_UPDATED', '')
    },
    handleDelete () {
      this.$confirm(this.$t('iDalgoDialogs.deleteTemplate.message'), this.$t('iDalgoDialogs.deleteTemplate.title'), {
        confirmButtonText: this.$t('actions.delete'),
        cancelButtonText: this.$t('actions.cancelButton'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('templates/deleteTemplate', this.template.id).then(() => {
          this.$notify({
            message: this.$t('iDalgoDialogs.deleteTemplate.notification')
          })
          this.$router.push({ name: 'templates' })
        })
      }).catch(() => {})
    },
    updateNotification () {
      this.$notify({
        title: this.$t('iDalgoListUpdateNotification.title'),
        message: this.$t('iDalgoListUpdateNotification.title')
      })
    },
    handleMediaUpdate (data) {
      this.card.media = data
    },
    showIntegrationLink () {
      this.integrationLink = iframeBundle(this.$route.params.id)
      this.integrationLinkDialogVisible = true
    },
    copyToClipboardHandler () {
      this.$clipboard(this.integrationLink)
      this.$message({
        type: 'success',
        message: this.$t('notifications.copy')
      })
    }
  },
  mounted () {
    this.$store.dispatch('templates/getTemplate', this.$route.params.id)
  },
  watch: {
    template () {
      if (!this.template || !this.template.name) {
        document.title = this.$t('head.title')
      } else {
        document.title = this.$t('head.title') + ' - ' + this.template.name
      }
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Template-Edit {

  .mainContent {
    display: flex;
    flex-direction: column;
  }

  .el-breadcrumb__item {
    .el-breadcrumb__inner {
      font-family: 'robotoregular' !important;
      font-weight: normal;
    }

    &:last-child .el-breadcrumb__inner {
      color: $color2 !important;
      font-family: 'robotoregular' !important;
    }
  }

  .template-time {
    color: lighten($text-gray, 10%);
    font-size: 11px;
    margin-right: $default_padding;
    padding: 0;
    display: inline-flex;
    margin: 20px $default_padding 4px $default_padding;

    b {
      margin-left: $default_padding / 2;
    }
  }

  .button-icon {
    border: none;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s;

    span {
      transition: all 0.2s;
    }

    .svg-icon {
      transition: all 0.2s;
    }

    &:hover {
      span {
        color: $color1;
      }
      .svg-icon {
        fill: $color1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-Template-Edit.vue